import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import { X } from 'react-feather';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CONSTANTS } from '../../../constants/constants';
import { FiltersContext } from '../../../pages/NRReportTabs/NRReportFilterContextWrapper';
import useTheme from '@mui/material/styles/useTheme';
import EllipsisTypography from '../../EllipsisTypography/EllipsisTypography';
export const DRAWER_WIDTH = '650px';

const { CLOSE } = CONSTANTS.ACTIONS;

export const DrawerMainContainer = ({ children, sx, ...props }) => (
  <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', ...sx }} {...props}>
    {children}
  </Box>
);

export const DrawerContent = ({ children, sx, ...props }) => (
  <Box sx={{ flexGrow: 1, overflowY: 'auto', ...sx }} {...props}>
    {children}
  </Box>
);

export const DrawerHeader = ({ drawerTitle, drawerTitleExtraComponents, handleClose, titleId, autoFocusCloseButton = false }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: theme.spacing(8),
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 3)
      }}
    >
      <EllipsisTypography id={titleId} variant="h3" component="div" mt={0.5} children={drawerTitle} />
      {drawerTitleExtraComponents}
      <IconButton aria-label="Close" onClick={handleClose} size="small" autoFocus={autoFocusCloseButton}>
        <X fontSize={12} />
      </IconButton>
    </Box>
  );
};

export const DrawerFooter = ({ hasBack, handleBack, handleClose }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: theme.spacing(8),
        minHeight: theme.spacing(8),
        padding: theme.spacing(1, 3),
        display: 'flex',
        alignItems: 'center',
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        zIndex: 1
      }}
    >
      {hasBack && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleBack}
          data-testid={'cancel-footer-button-drawer'}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <ArrowBackIcon style={{ fontSize: 18, marginTop: -2 }} />
          <Box component="span" sx={{ lineHeight: 1.75 }}>
            Back
          </Box>
        </Button>
      )}
      <Button sx={{ marginLeft: 'auto' }} variant="contained" color="secondary" onClick={handleClose} data-testid={'cancel-footer-button-drawer'}>
        {CLOSE}
      </Button>
    </Box>
  );
};

function NRClickThroughDrawer() {
  const {
    openDrawer,
    setOpenDrawer,
    drawerContent,
    drawerTitle,
    setDrawerTitle,
    hasBack,
    setDrawerContent,
    setHasBack,
    drawerTitleExtraComponents,
    setDrawerTitleExtraComponents
  } = useContext(FiltersContext);

  const handleBack = () => {
    setHasBack(drawerContent.length - 1 > 1);
    setDrawerTitle(drawerTitle.slice(0, -1));
    setDrawerContent(drawerContent.slice(0, -1));
  };

  const handleClose = () => {
    setHasBack(false);
    setOpenDrawer(false);
    setDrawerContent([]);
    setDrawerTitleExtraComponents(null);
    setDrawerTitle([]);
  };
  return (
    <Drawer
      PaperProps={{
        sx: { width: DRAWER_WIDTH, overflow: 'hidden' },
        role: 'dialog',
        'aria-modal': true,
        'aria-labelledby': 'nr-click-through-drawer-title'
      }}
      anchor={'right'}
      open={openDrawer}
      variant={'temporary'}
      onClose={() => handleClose()}
      onKeyDown={event => {
        if (event.key === 'Escape') {
          handleClose();
        }
      }}
    >
      <DrawerMainContainer>
        <DrawerHeader
          titleId="nr-click-through-drawer-title"
          autoFocusCloseButton={openDrawer}
          drawerTitle={!!drawerTitle && !!drawerTitle.length ? drawerTitle.at(-1) : ''}
          drawerTitleExtraComponents={drawerTitleExtraComponents}
          handleClose={handleClose}
        />
        <DrawerContent>{!!drawerContent && !!drawerContent.length && drawerContent[drawerContent.length - 1]}</DrawerContent>
        <DrawerFooter hasBack={hasBack} handleBack={handleBack} handleClose={handleClose} />
      </DrawerMainContainer>
    </Drawer>
  );
}

export default NRClickThroughDrawer;
